





































































import draftType from '@/store/types/drafts';
import { AxiosError } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import SweetAlert from '@/util/classes/SweetAlert';
import ProfileMenu from '@/components/Inbound/newVersion/ProfileMenu.vue';
import image from '@/assets/images/no-image-available.png';
import { itemsRoute } from '@/ts/navegationLinks';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const teipNotification = new TeipNotifications();

export default Vue.extend({
  name: 'CommerceToBeApproved',
  components: {
    ProfileMenu,
  },
  data: () => ({
    tryToRegister: false,
    image,
    editBranches: false,
    editProfile: false,
    modalShow: false,
    imageModal: '',
    loading: true,
    data: {},
    erros: {},
    items: [
      {
        id: 1,
        icon: 'ni ni-circle-08',
        title: 'Perfil',
        route: 'commerce-inbound-id',
        hash: 'profile',
      },
      {
        id: 2,
        icon: 'fas fa-file-alt',
        title: 'Documentos',
        route: 'commerce-inbound-documents',
        hash: 'documents',
      },
      {
        id: 3,
        can: 'index_contacts',
        icon: 'ni ni-circle-08',
        title: 'Contactos',
        route: 'commerce-inbound-contacts',
        hash: 'contactos',
      },
      {
        id: 4,
        can: 'index_branches',
        icon: 'ni ni-shop',
        title: 'Sucursales',
        route: 'commerce-inbound-branchs',
        hash: 'sucursales',
      },
      {
        id: 5,
        can: 'index_company_commerces',
        icon: 'ni ni-building',
        title: '', // Assigned in created
        route: 'commerce-inbound-commerces',
        hash: 'comercios',
      },
      {
        id: 6,
        can: 'show_bank_accounts',
        icon: 'ni ni-credit-card',
        title: 'Cuentas',
        route: 'commerce-inbound-bank-accounts',
        hash: 'cuentas',
      }
    ] as itemsRoute[],
    navlink: [
      {
        name: '', // assigned in created
        active: false,
        to: '/commerce/inbound',
      },
      {
        name: '', // Assigned in created
        active: true,
      }
    ],
  }),
  computed: {
    ...mapGetters({
      draftCompany: `drafts/${draftType.getters.GET_DRAFT_COMPANY}`,
    }),
  },
  created(): void {
    this.navlink[0].name = `${this.$t('menu.commerce.plural.formal')} por aprobar`;
    this.navlink[1].name = `Dar de alta al ${this.$t('menu.commerce.singular.informal')}`;
    this.items[5].title = this.$t('menu.commerce.plural.formal').toString();
  },
  async mounted(): Promise<void> {
    await this.singleInbound(this.$route.params.commerce_id);
    this.loading = false;
  },
  methods: {
    ...mapActions({
      registerDraftCompanyFn: `drafts/${draftType.actions.REGISTER_DRAFT_COMPANY}`,
      singleInbound: `drafts/${draftType.actions.SINGLE_DRAFT_COMPANY}`,
    }),
    registerDraftCompany(): void {
      !this.tryToRegister && this.openAlert();
    },

    openAlert(): void {
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: '¿Estás seguro?',
          text: 'Deseas dar de alta el Comercio?',
          cancelButtonText: 'No',
          confirmButtonText: 'Continuar',
          alertType: 'question',
        })
        .then((res: boolean) => {
          res && this.approveCommerce();
        });
    },

    approveCommerce(): void {
      this.tryToRegister = true;
      this.registerDraftCompanyFn(this.draftCompany.id)
        .then(() => {
          teipNotification.success('Perfil dado de alta satisfactoriamente');
          this.singleInbound(this.draftCompany.id);
        })
        .catch((err: AxiosError) => {
          if (err.response?.status === 422) {
            this.$data.errors = err.response.data.error;
          } else {
            teipNotification.warning(
              'Ha ocurrido un error al tratar de dar de alta el comercio'
            );
          }
        })
        .finally(() => {
          this.tryToRegister = false;
        });
    },
  },
});
